// ── PLE Theme Database ──────────────────────────────────────────────
export const PLE_THEMES = {
  'wrestlemania':       { color: '#d4af37', bg: '/ples/wrestlemania_bg.png' },
  'summerslam':         { color: '#e67e22', bg: '/ples/summerslam_bg.png' },
  'survivor-series':    { color: '#e74c3c', bg: '/ples/survivor-series_bg.png' },
  'elimination-chamber':{ color: '#95a5a6', bg: '/ples/elimination-chamber_bg.png' },
  'money-in-the-bank':  { color: '#2ecc71', bg: '/ples/money-in-the-bank_bg.png' },
  'hell-in-a-cell':     { color: '#c0392b', bg: '/ples/hell-in-a-cell_bg.png' },
  'backlash':           { color: '#922b21', bg: '/ples/backlash_bg.png' },
  'night-of-champions': { color: '#d4af37', bg: '/ples/night-of-champions_bg.png' },
  'clash-in-paris':     { color: '#1a6bb5', bg: '/ples/clash-in-paris_bg.png' },
  'crown-jewel':        { color: '#9b59b6', bg: '/ples/crown-jewel_bg.png' },
  'battleground':       { color: '#7f8c8d', bg: '/ples/battleground_bg.png' },
  'evolution':          { color: '#d4af37', bg: '/ples/evolution_bg.png' },
  'great-american-bash':{ color: '#e74c3c', bg: '/ples/great-american-bash_bg.png' },
  'halloween-havoc':    { color: '#e67e22', bg: '/ples/halloween-havoc_bg.png' },
  'no-mercy':           { color: '#2c3e50', bg: '/ples/no-mercy_bg.png' },
  'worlds-collide':     { color: '#16a085', bg: '/ples/worlds-collide_bg.png' },
};

export const getPLETheme = (pleId) => PLE_THEMES[pleId] || { color: '#d4af37', bg: null };
export const getPLEBg = (pleId) => pleId ? process.env.PUBLIC_URL + '/ples/' + pleId + '_bg.png' : null;
